// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB7YO7ucvn9pEtKJuCQbGenrQaTgM8hc5k",
    authDomain: "diegopolodigitaldesign.firebaseapp.com",
    projectId: "diegopolodigitaldesign",
    storageBucket: "diegopolodigitaldesign.firebasestorage.app",
    messagingSenderId: "441894627499",
    appId: "1:441894627499:web:2424b8f782b2fa839f6fee",
    measurementId: "G-BM9WLZ4DEH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore(app);

export { db };